import React from "react";
import Button from "../inputs/button";

// A save refused because someone else saved this audience after it was opened (ASB-4801):
// the API's message, kept on screen with a way to reload. Reloading shows their changes;
// the user's unsaved edits are lost, which the message says before they choose to.
// Shared by the V2 builder and the modeled and signal pages.
export const concurrentChangeToast = (error) => ({
	status: "Invalid",
	title: "Not saved",
	message: error.data.message,
	autoHide: false,
	action: (
		<Button
			text="Reload audience"
			type="button"
			style="light"
			size="sm"
			disabled={false}
			loaded={false}
			onClick={() => window.location.reload()}
		/>
	),
});
